<template>
	 <div v-bind:class="{ framePicker: true, active: active, relative: true }">
		<div v-if="!loading && frames && steps.pictureWall" class="row">

			<div v-bind:class="{ articleContainer: true, several: several }">

			    <div class="centerSlider" id="frameArticleSlider">

			    	<div
			    	data-field="all"
			    	class="item">
					    <div class="productShell">
				        	<img v-bind:src="wgURL +'/general/dummy-article.jpg'">
				        	<div class="label"> {{ $t('allArticles') }} </div>
				        </div>
				    </div>

				    <div
				    v-bind:data-field="index"
				    v-if="getFrameField(index)"
				    v-for="(article, index) in articles" :key="index" class="item">
				    	<div v-if="!chosenArticles[getArticleFieldID(article.item)]" class="inner">
			              <div class="productShell">
			              		<img v-bind:src="wgURL + '/general/dummy-article.jpg'">
			              		<!--<div class="label">{{ article.size }}</div>-->
			               </div>
			            </div> <!-- inner -->
			            <div class="chosenArticle" v-else>
			            	<div class="inner">
			            		<img v-bind:src="getArticleImage(chosenArticles[index + 1])">
			            	</div>
			            </div>
				    </div> <!-- item -->

			    </div> <!-- frameArticleSlider -->

			</div> <!-- four columns -->

			<div v-if="active" id="bottomFrameContainer" class="framesContainer">

				<div class="listing" id="frameSlider">

					<div
					v-on:click="deleteFrames(frame)"
					class="frameItem item third deleteFrameItem show-for-mobile-inline activePop">
				    	<div class="deleteFrameItemPic"> <i class="fa fa-trash"></i> </div>
				    </div>

					<div
					v-on:click="pickFrame(name, frame)"
					v-for="(frame, name) in frames['list']"
					:key="frame.id"
					class="frameItem item third smooth activePop">
				    	<img v-bind:src="getArticleImageDB(frame)">
				    </div>
				</div> <!-- frameSlider -->

			</div> <!-- framesContainer -->

			<div v-on:click="deleteFrames" class="hide-for-mobile" id="removeFramesContainer">
				<div id="removeFrames" class="button">
					<i class="fa fa-trash"></i> {{ $t('removeFrame') }}
				</div> <!-- removeFrames -->
			</div> <!-- removeFrames -->

		</div> <!-- row -->

		<div v-if="!steps.pictureWall" class="noPictureWall">
			 {{ $t('choosePictureWallBeforeFrames') }}
		</div> <!-- noPictureWall -->

		<loader fade-in="fadeIn" fade-out="fadeOut" classes="cover dimmer" identifier="framesPicker"></loader>

  	</div> <!-- framePicker -->

</template>

<script>

export default {

	data: function(){
		return{
			active: false,
			frames: false,
			currentField: 0,
			slidersInit: false,
			centerScroller: false,
			heightTries: 0,
			several: true,
			wgURL: window.appSettings.wgURL,
		}
	},

	props: ['listData'],

	computed: {

		articles(){
			// Get data
			var currentWall = this.$store.state.pictureWall

			// Check if article data exists
			if(typeof this.$store.state.pictureWall.articles != undefined && this.$store.state.pictureWall.articles){

			  // Parse JSON
			  return this.$store.state.pictureWall.articles

			}

			// Return if empty
			return []
	    },

	    chosenArticles(){
	      return this.$store.state.chosenArticles;
	    },

	    loading(){
	    	return this.$store.state.loading.framesPicker;
	    }

  	},

	methods: {

		get(){

			var self = this;

			self.currentField = 0;
			self.$store.commit('startLoading', 'framesPicker');

			// API returns the data after ajax loading
	        window.apiHandler.frameswG(function(data){

				// Set data
				self.$set(self, 'frames', data);

				// Init sliders
				window.vueRender(function(){
					self.initSliders()
				})

				// Stop loading
				self.$store.commit('stopLoading', 'framesPicker');

	        });

		},

		initSliders: function()
		{
			var self = this;

			// Import plugins
			require('../../../build/modules/slider.js')
			require('jquery-mousewheel')

			// The element that will be used for our centerScroller
			self.centerScroller = $("#frameArticleSlider")

			if(self.centerScroller.hasClass("slick-initialized")){
				self.centerScroller.slick('unslick')
				self.centerScroller.unbind();
			}

			var slidesToShow = 3;
			self.several = true;

			if(Object.keys(self.chosenArticles).length == 2){
				slidesToShow = 1;
				self.several = false;
			}

			self.centerScroller.slick({

				arrows: true,
				centerMode: true,
				centerPadding: '9px',
				slidesToShow: slidesToShow,
				responsive: [
				 {
			      breakpoint: 1532,
			      settings: {
			       	centerPadding: '7px',
			      }
			    },
			    {
			      breakpoint: 1332,
			      settings: {
			       	centerMode: false,
			       	slidesToShow: 1,
			      }
			    }
			    ]
			});

			// Add change slide on click functionality
			self.centerScroller.on("click", '.slick-slide', function(){
				self.pickCenterSlider($(this).attr("data-slick-index"))
			});

			// Keep track of change
			self.centerScroller.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				self.currentField = nextSlide;
			});

			// Check height
			self.setHeightScroller();

		},

		setHeightScroller(){

			var self = this;

			var highestSlide = 0
			$("#frameArticleSlider").find(".slick-slide").each(function(){
				var height = $(this).height()

				if(height > highestSlide)
					highestSlide = height
			});

			if(highestSlide < 50 && self.heightTries < 150){
				setTimeout(

				  function()
				  {
				  	self.heightTries = self.heightTries + 1;
				    self.setHeightScroller();
				  }, 100)
			}
			else{
				$("#frameArticleSlider").height(parseInt(highestSlide) * 1.2)
			}

		},

		pickCenterSlider(index){
			this.centerScroller.slick('slickGoTo', index);
		},

		pickFrame: function(name, frame){

			var self = this;

			var fieldsToPick = [];
			var chosenFrames = self.$store.state.chosenFrames

			// If all
			if(self.currentField == 0){
				$.each(self.articles, function(index, value){
					fieldsToPick.push(index + 1);
				});

			}
			// If only specific
			else{
				fieldsToPick.push(self.currentField);
			}

			$.each(fieldsToPick, function(index, value){

				// Get size for this particular field
				var size = self.$store.state.pictureWall.articles[index].size;

				chosenFrames[value] = self.frames.framesPerSize[size][name];

				self.$store.commit('chosenFrames', chosenFrames)
			});

			// Update price
			this.$store.commit('calculatePrice');

			this.trackEvent('frame step');
		},

		deleteFrames: function(frame){

			var self = this;

			var fieldsToPick = [];
			var chosenFrames = self.$store.state.chosenFrames

			// If all
			if(self.currentField == 0){
				$.each(self.articles, function(index, value){
					fieldsToPick.push(index + 1);
				});

			}
			// If only specific
			else{
				fieldsToPick.push(self.currentField);
			}

			$.each(fieldsToPick, function(){
				chosenFrames[this] = false;
				self.$store.commit('chosenFrames', chosenFrames)
			});

			// Update price
			this.$store.commit('calculatePrice');

		},

		getFrameField: function(index){

			return true;

		},

		getArticleFieldID: function(itemNumber){
	      return itemNumber;
	    },

		close: function(){
		  this.active = false
		  this.$store.commit('leftTitle', '')
		},

	},

	created: function () {

		var self = this;

		// When user clicked pictureWall
		window.eventHub.$on('clickedPictureWallItem', function () {

			if(self.currentPicker == 'frames')
			{
				var currentWallField = self.$store.state.currentWallField
				self.pickCenterSlider(currentWallField)
			}
		});

		// When we want to open frame picker
		window.eventHub.$on('openFramePicker', function () {

		  	if(!self.active){
		  		self.closePickers('framePicker')
			    self.active = true;
			    self.$store.commit('currentPicker','frames')
			    self.$store.commit('leftTitle', self.$i18n.t("frames"))
			    self.get();
		  	}
		  	else
		  		self.close();
		});

		// Close picker event
		window.eventHub.$on('closePickers', function (type) {
			if(type != 'framePicker')
				self.close();
		});

	}
}
</script>

<style lang="scss">
.framePicker{
	width: 100%;
	height: 0;
	overflow: hidden;
	-webkit-transform: translate3d(-100%,0,0);
	transform: translate3d(-100%,0,0);
	-webkit-transition: -webkit-transform 0.2s;
	transition: -webkit-transform 0.2s;
	-o-transition: transform 0.2s;
	transition: transform 0.2s;
	transition: transform 0.2s, -webkit-transform 0.2s;
	-webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
	-o-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
	transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);

	.articleContainer{
		/*width: 200px;*/
		margin: auto;
		margin-top: 20px;
		margin-bottom: 20px;

		/* Mobile */
		@media screen and (max-width: 844px) {
		    margin-top: 6px;
    		margin-bottom: 6px !important;
		   width: 100%;
		   margin-bottom: 0;
		}
	}

	.noPictureWall{
		padding: 20px;
	    text-align: center;
	    font-size: 13px;
	}

	.framesContainer{
		width: 100%;

		/* Mobile */
		@media screen and (max-width: 844px) {
			overflow-y: scroll;

			&::-webkit-scrollbar {
	        	-webkit-appearance: none;
	        	width: 5px;
		    }
			&::-webkit-scrollbar-thumb {
		        border-radius: 4px;
		        background-color: rgba(0,0,0,.5);
		        -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
		    }
		}
	}


	.centerSlider{
		width: calc(100% - 60px);
    	margin: auto;

		@media screen and (min-width: 1333px) {
			.item{
				transform: scale(0.7);
				opacity: 0.6;
			}

			.slick-current{
				transform: scale(1);
				opacity: 1;
			}
		}

		.slick-list, .slick-track{
			height: 100%;
		}

	}

	.item{
		padding: 5px;
		padding-top: 8px;
   		padding-bottom: 0px;
		text-align: center;
		cursor: pointer;

		@media screen and (max-width: 844px) {
			padding-top: 5px;
		}

		&:hover{
			opacity: 0.8;
		}

		&.all{
			font-size: 40px;
		}

		img{
			max-width: 100%;
	    	max-height: 175px;
	    	margin: auto;

	    	/* Mobile */
			@media screen and (max-width: 844px) {
				max-height: 130px;
			}

		}

		&[data-field="all"] div {
			height: 100%;
			img { display: none; }
		}

		/* Shell for not selected article */
		.productShell{
		    position: relative;

		    img{
		    	border: 1px solid black;
		    }
		}

		/* Size text inside productShell */
		.label{
			font-size: 15px;
		    position: absolute;
		    top: 50%;
		    margin-top: -12px;
		    width: 100%;
    		line-height: 16px;

		    /* Mobile */
			@media screen and (max-width: 844px) {
				font-size: 14px;
			}

		}

		.chosenArticle{

			display: table;
			width: 100%;

			height: 100%;

			.inner{
				vertical-align: middle;
				display: table-cell;
				text-align: center;
			}

		}

	}


	.several .item img{
		width: 100%;
	}


	.frameItem{
		padding: 15px;
		cursor: pointer;
		min-height: 0;

		/* Mobile */
		@media screen and (max-width: 844px) {
			padding: 6px;
			width: 49% !important;
			max-width: 49% !important;
		}

		&:hover{
			opacity: 0.8;
		}

		img{
			width: 100%;
		}

		/* Base product / shell image size */
		img{
	    	max-width: 100%;
    		max-height: 175px;
    		margin: auto;
	    }
	}

}

#removeFramesContainer{
	padding: 0 15px;
	@media screen and (max-width: 844px) {
		padding: 0 3px;
	}
}

#removeFrames{
	width: 100%;

	@media screen and (max-width: 844px) {
		padding: 0;
	    margin-top: 5px;
	    font-size: 9px;
	    height: 33px;
	    line-height: 33px;
	}
}

.deleteFrameItemPic{
	width: 100%;
    padding-bottom: 133%;
    height: 0;
    overflow: hidden;
    position: relative;
    background: #e8e8e8;
    border: 1px solid black;

    @media screen and (max-width: 844px) {
    	padding-bottom: 137%;
    }

    .fa{
    	width: 100%;
    	position: absolute;
    	left: 0;
    	top: 50%;
    	margin-top: -8px;
    	text-align: center;
    }
}

.framePicker.active{
	-webkit-transform: translate3d(0,0,0);transform: translate3d(0,0,0);
	height: auto;
	height: calc(100% - 130px);
	overflow: auto;

	@media screen and (max-width: 844px) {
		height: calc(100% - 37px) !important;
	}
}

</style>



// WEBPACK FOOTER //
// FramePicker.vue?7573c86a